const Badges = [
  {
    id: 'bestSelection',
    name: 'storeFinderBestSelection',
    cssClass: 'text-black',
  },
  {
    id: 'sale',
    name: 'storeFinderSale',
    cssClass: 'text-black',
  },
];

export {Badges};
